import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DatalayerService } from 'src/services/datalayer.service';

@Component({
  selector: 'app-insights-panel',
  templateUrl: './insights-panel.component.html',
  styleUrls: ['./insights-panel.component.scss']
})
export class InsightsPanelComponent implements OnInit, OnDestroy {
  private submitMessageListener = this.handleMessage.bind(this);
  insightsUrl!: SafeResourceUrl;
  insightsBaseDomain: string;

  constructor(private translate: TranslateService,
    private sanitizer: DomSanitizer,
    private datalayerService: DatalayerService) {}

  ngOnInit(): void {
    this.updateInsightsUrl();
    
    this.translate.onLangChange.subscribe(() => {
      this.updateInsightsUrl();
    });
    
    window.addEventListener('message', this.submitMessageListener);
  }

  private updateInsightsUrl(): void {
    this.insightsBaseDomain = this.translate.instant('Home.insightsDomain');
    const rawUrl = this.translate.instant('Home.insights');
    this.insightsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(rawUrl);
  }

  private handleMessage(event: MessageEvent): void {
    // Verify the origin of the message
    if (event.origin == this.insightsBaseDomain && event.data == 'formSubmitted') {
      this.datalayerService.insightsClick(event.data.formUrl); 
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener('message', this.submitMessageListener);
  }
}